import { CmsIcons } from '@redteclab/api/clients/content-management-system'

import { ICON_TO_COMPONENT_MAP } from 'views/components/atoms/Icon/consts'

export const getRebrandingMenubarIcons = (iconProvided: CmsIcons) => {
  if (iconProvided === CmsIcons.Ods) {
    return ICON_TO_COMPONENT_MAP.doctor
  }
  if (iconProvided === CmsIcons.New) {
    return ICON_TO_COMPONENT_MAP.nowAvailable
  }

  return ICON_TO_COMPONENT_MAP[iconProvided]
}
